import React from 'react';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';
import ConfirmDialog from './ConfirmDialog.jsx';
import moment from 'moment';
import { connect } from 'react-redux';
import { Toastr } from 'modules/toastr';
import { API_URL } from 'constants/config';
import ThongTinYeuCauKiemTraDeXuat from './ThongTinYeuCauKiemTraDeXuat.jsx';
import { GiaiQuyetDonThu, Danhmuc, DuLieuHeThong } from 'api';
import { ShowIf, ShowIfCheck } from 'components/utils';
import {Dialog} from "@blueprintjs/core";
import {
  DropDownChonCanBoXuLy,
  DropDownChonPhongBanThuocCoQuan,
  DropDownChonCanBoGiaiQuyet,
  DropDownMulipleUse,
  DropDownChonKetLuanNoiDungKhieuNai,
  DropDownChonKetQuaThucHien,
  DropDownChonKetQuaGiaiQuyet,
  DropDownChonCoQuanDieuTra,
  DropDownNguoiKy
} from 'components/tt-forms';
import {TextArea, DatePicker, Input, InputNumber, TextMessage, Text} from 'components/tt-forms/common';
import { Link, browserHistory } from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import {checkThamSo} from "constants/checkThamSo";
import { isEmpty } from 'lodash';

const vaiTro = 'CHUYEN_VIEN';
const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'THAM_TRA_XAC_MINH';
const buocGiaiQuyet = null;

class GiaiQuyetDonTruongPhong extends React.Component {
  constructor(props, context) {
    let gqText = '';
    if (props.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH') {
      gqText = 'Ban hành văn bản giải quyết';
    } else {
      if (props.loaiDon == 'DON_TO_CAO') {
        gqText = 'Ban hành kết luận nội dung tố cáo';
      } else {
        gqText = 'Ban hành quyết định giải quyết';
      }
    }
    super(props, context);
    this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTraDon: false,
      openDialogTruongPhongTTXM: false,
      focused: false,
      loaiDon: this.props.loaiDon,
      id: this.props.id,
      role: this.props.roleGQ,
      validate: false,
      showAttach: false,
      ListTaiLieuVanThu: [],
      ListTaiLieuVanThuShow: [],
      onSave: false,
      canBoGiaiQuyet: '',
      ngayHetHanKTDX: '',
      dataGiaiQuyetDon: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataNextState: [],
      ketLuanNoiDungKhieuNaiGiaoTTXM: '',
      noiDung: '',
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: this.props.coQuanQuanLyNguoiDung,
      nextState: '',
      lyDoQuaHan: '',
      phongBanChiDinh: '',
      openDialogLuuHoSo: false,
      componentsLoading: true,
      isValid: false,
      tTXMRequired: false,
      open: false,
      showFile: false,
      lapToDoanXacMinh: false,
      giaHanGiaiQuyet: false,
      giaHanTTXM: false,
      doiThoai: false,
      giaoCoQuanDieuTra: false,
      quyetDinhGiaiQuyetKhieuNai: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,
      allowAttachGiaoCoQuanDieuTra: false,
      khongCoCoQuanTheoDoiThucHien: false,
      checkThanhTraThanhPho: false,
      isThanhTraThanhPho: false,

      //dialog
      btnText: '',
      titleDialog: '',
      contentDialog: '',
      //end

      isPhongBanThanhTra: false,
      checkPhongBanThanhTra: false,
      valueKetQua: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      dataFileDinhKem: {
        baoCaoKetQuaTTXM: [],
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      dataCoQuanTheoDoi: [],

      soQuyetDinhThanhLapDTXM: '',
      truongDoanTTXM: '',

      ketLuanNoiDungKhieuNai: '',

      //DON_KHIEU_NAI
      soQuyetDinhGiaHanTTXM: '',
      ngayRaQuyetDinhGiaHanTTXM: '',
      ngayHetHanSauKhiGiaHanTTXM: '',
      lyDoGiaHanGia: '',

      //DON_TO_CAO
      soQuyetDinhGiaHanGiaiQuyet: '',
      ngayRaQuyetDinhGiaHanGiaiQuyet: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',

      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',
      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      soVuGiaiQuyetKhieuNai: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      yKienGiaiQuyet: '',

      tienPhaiThuNhaNuocQDGQ: '',
      tienPhaiTraCongDanQDGQ: '',
      datPhaiThuNhaNuocQDGQ: '',
      datPhaiTraCongDanQDGQ: '',
      soNguoiDuocTraLaiQuyenLoi: '',

      noiDungDoiThoai: '',
      soLanGiaiQuyetLai: '',
      ketQuaThucHienKhac: '',
      ketQuaKhac: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',
      listTaiLieuVanThuGiaiQuyetDonView: this.props.listTaiLieuVanThuGiaiQuyetDonView,
      allowAttach: false,
      isSoBanNganh: false,
      checkSoBanNganh: false,
      dataDonViTheoDoi: [],
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      huongGiaiQuyet: '',
      ngayBanHanhSuggest: '',
      tenDonViTheoDoiThucHien: '',
      ketQuaXLDGiaiQuyet: '',
      dataKetQuaGiaiQuyetDon: [],
      tienDoDoiThoai: '',
      message: `Chọn "${this.gqText}" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?`,
      coQuanTheoDoiThucHien: {},
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      allowTDTH: false,
      tenCoQuan: this.props.tenCoQuan,
      gqText,
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    this.initHuongXuLyData(this.props.dataNextStates, 'dataNextState');
    this.getDonViTheoDoi();
    this.getCoQuanTheoDoiEnumn();
    this.getListPhongBanNhanTDTH();
    this.getKetQuaGiaiQuyetDon();
    if (window.debug) {
      console.log('giai-quyet-don/subView/GiaiQuyetDonCanBo');
    }
    if (this.props.tenCoQuan.length === 0) {
      DuLieuHeThong.actions.getDonViTTXM.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'donViTTXM',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        });
      });
    }
  }

  initHuongXuLyData(inputData, name) {
    let ttxmText = this.props.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let ttxmText1 = this.props.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH' ? ttxmText+' và dự thảo văn bản GQ' : ttxmText;
    let getPhongBan = [...inputData].filter(item => {
      if (item.type === "GQDTTTXM_GIAO_PHONG_CUNG_CAP" || item.type === "NHANTTXM_GIAO_PHONG_CUNG_CAP") {
        return item;
      }
    });
    if (getPhongBan.length) {
      let phoPhong = {
        stateId : getPhongBan[0].stateId,
        ten: "Trưởng phòng giao việc phó phòng",
        tenVietTat: "Giao việc phó phòng",
        type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
      };
      inputData.push(phoPhong);
    }
    let outputData = [...inputData];
    outputData = outputData.map(item => {
      if (item.type === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
        return item = {
          ...item,
          tenVietTat : `Gửi báo cáo ${ttxmText1}`,
          ten : `Gửi báo cáo ${ttxmText1}`
        }
      }
      if (item.type === 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
        return item = {
          ...item,
          tenVietTat : `Trả đơn do chuyển ${ttxmText} không đúng`,
          ten : `Trả đơn do chuyển ${ttxmText} không đúng`
        }
      }
      if (item.type === 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH' || item.type === "CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN") {
        return item = {
          ...item,
          tenVietTat : "Tự giải quyết",
          ten : "Tự giải quyết"
        };
      }

      return item;
    });
    let getTheoDoiThucHien = outputData.find(item => item.type === "CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH");
    if (getTheoDoiThucHien) {
      outputData = outputData.filter(item => item.type !== "KET_THUC" && item.type !== "CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN");
    } else {
      outputData = outputData.filter(item => item.type !== "KET_THUC");
    }
    this.setState({
      [name]: outputData
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.truongPhongThuHoi == true) {
      if (this.select && prevState.focused == false) {
        this.setState({
          focused: true
        });
        this.select.focus();
      }
    }
  }
  componentWillMount() {
    this.determinativeVaiTro();
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        donViId: userInfo.donViId
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.dataNextStates && nextProps.dataNextStates !== this.props.dataNextStates) {
      this.initHuongXuLyData(nextProps.dataNextStates, 'dataNextState');
    }
    if (nextProps.tenCoQuan !== this.props.tenCoQuan) {
      this.setState({
        ...this.state,
        tenCoQuan: nextProps.tenCoQuan
      });
    }
  }

  getDonViNhanTheoDoiTH() {
    let params = {
      donId: this.props.id,
      tuTTXM: true,
      loaiDon: this.props.loaiDon
    };
    GiaiQuyetDonThu.actions.getDonViNhanTDTH.request(params).then(res => {
      if (res.data) {
        this.setState({coQuanTheoDoiThucHien: res.data, allowTDTH: true});
      }
      this.initButton();
    }).catch(err => {
      this.initButton();
    });
  }

  getKetQuaGiaiQuyetDon() {
    let params = {
      banHanhQuyetDinh: true,
      khongCoDoiThoai: false,
      loaiDon: this.props.loaiDon
    };
    GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(res => {
      if (res.data) {
        this.setState({
          dataKetQuaGiaiQuyetDon: res.data
        });
      }
    });
  }

  checkSoBanNganh() {
    let params = {
      tuKhoa: 'CCQQL_SO_BAN_NGANH'
    };
    Danhmuc.actions.getThamSo.request(params).then(res => {
      if (res.data._embedded && res.data._embedded.thamSoes && res.data._embedded.thamSoes.length > 0) {
        let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
        if (Number(userInfo.capCoQuanQuanLyCuaDonViId) === Number(res.data._embedded.thamSoes[0].giaTri)) {
          this.setState({
            isSoBanNganh: true,
            checkSoBanNganh: true
          }, () => {
            this.checkThanhTraThanhPho();
          });
        } else {
          this.setState({
            isSoBanNganh: false,
            isPhongBanThanhTra: false,
            checkPhongBanThanhTra: true,
            checkSoBanNganh: true,
            checkThanhTraThanhPho: true,
            isThanhTraThanhPho: false
          });
          this.getDonViNhanTheoDoiTH();
        }
      }
    }).catch(err => {
      this.setState({
        isSoBanNganh: false,
        isPhongBanThanhTra: false,
        checkPhongBanThanhTra: true,
        checkSoBanNganh: true,
        checkThanhTraThanhPho: true,
        isThanhTraThanhPho: false
      });
      this.getDonViNhanTheoDoiTH();
    });
  }

  checkThanhTraThanhPho() {
    let params = {
      tuKhoa: 'CQQL_THANH_TRA_THANH_PHO'
    };
    Danhmuc.actions.getThamSo.request(params).then(res => {
      if (res.data._embedded && res.data._embedded.thamSoes && res.data._embedded.thamSoes.length > 0) {
        let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
        this.setState({
          checkThanhTraThanhPho: true,
          isThanhTraThanhPho: Number(userInfo.donViId) === Number(res.data._embedded.thamSoes[0].giaTri)
        }, () => {
          this.getPhongBanNhanTDTH();
        });
      }
    }).catch(err => {
      this.setState({
        checkThanhTraThanhPho: true,
        isThanhTraThanhPho: false
      }, () => {
        this.getPhongBanNhanTDTH();
      });
    });
  }

  getListPhongBanNhanTDTH() {
    GiaiQuyetDonThu.actions.getListPhongBanNhanTDTH.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataPhongBanNhanTDTH: res.data._embedded.coQuanQuanLies
        });
      }
    });
  }

  getPhongBanNhanTDTH() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let ts = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    let idQuan = ts.filter(item => item.ten === 'CCQQL_UBND_QUAN_HUYEN');

    GiaiQuyetDonThu.actions.getPhongBanNhanTDTH.request().then(res => {
      if (res.data) {
        this.setState({
          donViTheoDoiThucHien: res.data.coQuanQuanLyId,
          tenDonViTheoDoiThucHien: res.data.ten,
          checkPhongBanThanhTra: true,
          allowTDTH: true
        });
      }
      this.initButton();
    }).catch(err => {
      // if (idQuan.length && userInfo.capCoQuanQuanLyCuaDonViChaId !== idQuan[0].giaTri && this.state.isThanhTraThanhPho === false) {
      //   Toastr('Không có cơ quan tiếp nhận theo dõi thực hiện', 'error');
      // }
      this.setState({
        checkPhongBanThanhTra: true,
        khongCoCoQuanTheoDoiThucHien: true,
      });
      this.initButton();
    })
  }

  getCoQuanTheoDoiEnumn() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanTheoDoi: res.data
        });
      }
    });
  }

  getDonViTheoDoi() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoi.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDonViTheoDoi: res.data._embedded.coQuanQuanLies
        });
      }
    });
  }

  initButton() {
    let coQuanQuanLyId = this.props.dataGiaiQuyet && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId ? this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId : '';
    let _btnText = 'Chuyển theo dõi thực hiện';
    let _titleDialog = 'Xác nhận';
    let _contentDialog = 'Không có đơn vị nhận theo dõi thực hiện?';
    if (this.state.donViTheoDoiThucHien === coQuanQuanLyId || this.state.donViTheoDoiThucHien === this.props.coQuanQuanLyNguoiDung.id || this.state.isThanhTraThanhPho || !this.state.allowTDTH) {
      _btnText = 'Lưu hồ sơ';
      _titleDialog = 'Xác nhận lưu hồ sơ';
      _contentDialog = 'Bạn có muốn lưu hồ sơ này?';
    } else if (!this.state.khongCoCoQuanTheoDoiThucHien) {
      if (this.state.isSoBanNganh) {
        _contentDialog = `Bạn có đồng ý chuyển đơn/vụ việc này cho ${this.state.tenDonViTheoDoiThucHien} theo dõi thực hiện không?`;
      } else {
        _contentDialog = `Bạn có đồng ý chuyển đơn/vụ việc này cho ${this.state.coQuanTheoDoiThucHien.ten} theo dõi thực hiện không?`;
      }
    }

    this.setState({
      tTXMRequired: true,
      btnText: _btnText,
      titleDialog: _titleDialog,
      contentDialog: _contentDialog
    }, () => {
      this.setState({
        componentsLoading: false
      });
    });
  }

  checkFileCoQuanDieuTra() {
    this.setState({
      allowAttachGiaoCoQuanDieuTra: false
    }, () => {
      if (this.state.giaoCoQuanDieuTra === false) {
        this.setState({
          allowAttachGiaoCoQuanDieuTra: true
        });
      } else {
        let taiLieuVanThuGiaoCoQuanDieuTra = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra] || [];
        let data = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra] || [];
        let dataCheck = data.filter(state => state.required && state.typeRequired === 'GIAO_CO_QUAN_DIEU_TRA');
        if (dataCheck.length > 0) {
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
            allowAttachGiaoCoQuanDieuTra: true
          });
        } else {
          let newItem = {
            ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
            newFile: true
          };
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: [
              ...taiLieuVanThuGiaoCoQuanDieuTra,
              newItem
            ],
            allowAttachGiaoCoQuanDieuTra: true
          });
        }
      }
    });
  }

  onChange(name, e) {
    let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    let getUserInfoId = userInfo.id;
    if (name === 'nextState' && e.target.value === 'KET_THUC') {
      this.setState({
        canBoGiaiQuyet: getUserInfoId
      });
    }
    if (name === 'nextState' && e.target.value === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
      this.setState({
        showAttach: false,
        yKienGiaiQuyet: '',
        canBoGiaiQuyet: '',
        noiDung: '',
        ketLuanNoiDungKhieuNaiGiaoTTXM: '',
        [name]: e.target.value
      }, ()=> {
        this.checkFileRequired();
      });
    } else if (name == 'nextState' && (e.target.value == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || e.target.value == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN')) {
      this.setState({
        yKienGiaiQuyet: '',
        canBoGiaiQuyet: '',
        noiDung: '',
        ketLuanNoiDungKhieuNaiGiaoTTXM: '',
        showAttach: false,
        [name]: e.target.value
      }, () => {
        this.filterFileRequired();
      });
    } else {
      this.setState({
        [name]: e.target.value
      });
    }

    if (name === 'ketQuaXLDGiaiQuyet' && e.target.value === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      this.setState({
        ...this.state,
        message: `Chọn "${this.state.gqText}" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?`,
        open: true,
        valueKetQua: e.target.value
      });
    } else if (name === 'ketQuaXLDGiaiQuyet' && e.target.value === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
      this.setState({
        ...this.state,
        message: 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?',
        open: true,
        valueKetQua: e.target.value
      });
    } else if(name === 'nextState') {
      if (e.target.value === 'KET_THUC') {
        this.setState({
          tTXMRequired: true,
          [name]: e.target.value
        });

      } else {
        this.checkFileRequired(e.target.value);
      }
    } else {
      if(name == 'tienDoDoiThoai' && e.target.value !== 'KHONG_DOI_THOAI') {
        this.state.tienDoDoiThoai = e.target.value;
        this.state.ketQuaXLDGiaiQuyet = '';
        this.setState({
          ...this.state
        })
      }
      let state = this.state;
      if (name === 'soLanGiaiQuyetLai' && Number(e.target.value) <= 1) {
          state.ketQuaGiaiQuyetLan2 = '';
      }

      if (name === 'ketQuaGiaiQuyetLan2' && Number(e.target.value) !== 'HUY_SUA_QDGQ_LAN_I') {
          state.noiDungKetLuanGiaiQuyetLai = '';
      }

      if (name === 'nextState' && e.target.value === 'CAN_BO_CHUYEN_DON_VI_TTXM') {
          state.tTXMRequired = false;
      }
      this.setState({
        [name]: e.target.value,
        state
      })
    }
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            phongBanChiDinh: res.data.phongBanGiaiQuyetInfo && res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            canBoGiaiQuyet: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
            lyDoQuaHan: res.data.lyDoQuaHan || '',
            noiDung: res.data.noiDung ? res.data.noiDung : '',
            giaHanTTXM: res.data.giaHanTTXM,
            giaHanGiaiQuyet: res.data.giaHanGiaiQuyet,
            nextStateInfo: res.data.nextStateInfo,
            nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : (res.data.nextStateInfo ? res.data.nextStateInfo.type : (this.props.truongPhongThuHoi == true ? 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' : '')),
            ngayHetHanSauKhiGiaHanTTXM: res.data.ngayHetHanSauKhiGiaHanTTXM ? moment(res.data.ngayHetHanSauKhiGiaHanTTXM).format('DD/MM/YYYY') : '',
            lyDoGiaHanTTXM: res.data.lyDoGiaHanTTXM ? res.data.lyDoGiaHanTTXM : '',
            ngayHetHanSauKhiGiaHanGiaiQuyet: res.data.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(res.data.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '',
            lyDoGiaHanGiaiQuyet: res.data.lyDoGiaHanGiaiQuyet ? res.data.lyDoGiaHanGiaiQuyet : '',
            soQuyetDinhThanhLapDTXM: res.data.soQuyetDinhThanhLapDTXM,
            truongDoanTTXM: res.data.truongDoanTTXMInfo ? res.data.truongDoanTTXMInfo.congChucId : '',
            ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : '',
            soQuyetDinhGiaHanTTXM : res.data.soQuyetDinhGiaHanTTXM ? res.data.soQuyetDinhGiaHanTTXM : '',
            ngayRaQuyetDinhGiaHanTTXM : res.data.ngayRaQuyetDinhGiaHanTTXM ? new Date(res.data.ngayRaQuyetDinhGiaHanTTXM) : '',
            soQuyetDinhGiaHanGiaiQuyet : res.data.soQuyetDinhGiaHanGiaiQuyet ? res.data.soQuyetDinhGiaHanGiaiQuyet : '',
            ngayRaQuyetDinhGiaHanGiaiQuyet : res.data.ngayRaQuyetDinhGiaHanGiaiQuyet ? new Date(res.data.ngayRaQuyetDinhGiaHanGiaiQuyet) : '',
            ngayHetHanGiaiQuyet : res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
            soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
            ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
            ngayBanHanhSuggest: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
            nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',
            thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
            diaDiemDoiThoai: res.data.diaDiemDoiThoai,
            coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
            soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra,
            soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra,
            tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
            datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
            tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
            datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
            tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
            soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,
            hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
            coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
            ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',
            khoiTo: res.data.khoiTo,
            soVuBiKhoiTo: res.data.soVuBiKhoiTo,
            soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,
            soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
            tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
            datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
            tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
            datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,
            lapToDoanXacMinh: res.data.lapToDoanXacMinh,
            doiThoai: res.data.doiThoai,
            giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
            quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
            theoDoiThucHien: res.data.theoDoiThucHien,
            lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
            lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',
            donViThamTraXacMinh: res.data.donViThamTraXacMinhInfo ? res.data.donViThamTraXacMinhInfo.coQuanQuanLyId : '',
            ngayHetHanTTXM: res.data.ngayHetHanTTXM ? new Date(res.data.ngayHetHanTTXM) : '',
            tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
            tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
            datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
            datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
            soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,
            ketQuaXLDGiaiQuyet: (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') ? res.data.ketQuaXLDGiaiQuyet : '',
            tienDoDoiThoai: 'KHONG_DOI_THOAI',
            showTienDoGiaiQuyet: (res.data.ketQuaXLDGiaiQuyet && (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) ? true : false,
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
            soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
            ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
            ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
            ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
            noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
            noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
            showFile: true,
            allowAttach: true
          },() => {
            this.checkOnlyState();
            if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
              this.checkFileRequired();
            } else {
              this.filterFileRequired();
            }
            this.checkFileCoQuanDieuTra();
          });
        }
        this.checkSoBanNganh();
      });
    }
  }

  checkOnlyState() {
    if(this.props.dataNextStates.length == 1) {
      this.setState({
        nextState: this.props.dataNextStates[0].type
      },()=> {
        if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
          this.checkFileRequired();
        }
        if (this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO') {
          this.filterFileRequired();
        }
      });
    }
  }

  filterFileRequired() {
    let dataShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(state => {
      return state.nguoiTaoInfo.donViId != this.state.donViId
    });
    dataShow = dataShow.filter(state => {
      return state.typeRequired != 'BC_KQTTXM' && state.typeRequired != 'KQTTXM_DTVBGQ'
    });
    if (this.props.donInfo && this.props.donInfo.laTTXMLai) {
      dataShow = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM;
    }
    this.setState({
      ListTaiLieuVanThuShow: dataShow,
      showAttach: true
    });
  }

  checkFileRequired() {
    this.setState({
      showFile: false
    });
    let listTaiLieuVanThuGiaiQuyetDonView = this.state.listTaiLieuVanThuGiaiQuyetDonView ? [...this.state.listTaiLieuVanThuGiaiQuyetDonView] : [];
    let dataCheckFileRequired = listTaiLieuVanThuGiaiQuyetDonView.filter(state => state.required && state.typeRequired === 'QD_GTTXM' );
    let data = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM.filter(state => state.nguoiTaoInfo.donViId === this.state.donViId );
    let dataShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(state => state.nguoiTaoInfo.donViId !== this.state.donViId );
    if (dataCheckFileRequired.length > 0) {
      // do nothing
      this.setState({
        showFile: true
      });
    } else {
      let fileRequired = {
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'QD_GTTXM'
      };
      if (this.state.loaiDon === 'DON_KHIEU_NAI') {
        fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại';
      } else if (this.state.loaiDon === 'DON_TO_CAO') {
        fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung tố cáo';
      } else {
        fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung kiến nghị phản ánh';
      }
      let listTaiLieuVanThuGiaiQuyetDonView = this.state.listTaiLieuVanThuGiaiQuyetDonView ? [...this.state.listTaiLieuVanThuGiaiQuyetDonView,fileRequired] : [];
      this.setState({
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        showFile: true
      });

    }
    if (this.props.loaiDon === 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO' || this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
      let isTTXML = this.props.donInfo && this.props.donInfo.laTTXMLai ? true : false;
      if (isTTXML === true) {
        dataShow = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView.filter(item => item.typeRequired != 'BC_KQTTXM_L' );
        data = data.filter(item => item.typeRequired !== 'BC_KQTTXM' && item.typeRequired !== 'KQTTXM_DTVBGQ' );
      }
      let checkKQTTXM = data.filter(item => {
        if (isTTXML === true)
          return item.typeRequired == 'BC_KQTTXM_L';
        else
          return item.typeRequired == 'BC_KQTTXM';
      });
      if (checkKQTTXM.length === 0) {
        let itemKQTTXM = {
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: isTTXML == true ? 'BC_KQTTXM_L' : 'BC_KQTTXM',
          newFile: true
        };
        if (this.props.loaiDon === 'DON_TO_CAO') {
          itemKQTTXM.ten = 'Báo cáo Kết quả xác minh nội dung tố cáo'+(isTTXML == true ? ' (Lần 2)' : '');
        } else if (this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
          itemKQTTXM.ten = 'Văn bản xác minh đề xuất'+(isTTXML === true ? ' (Lần 2)' : '');
        } else {
          itemKQTTXM.ten = 'Báo cáo Kết quả xác minh nội dung khiếu nại'+(isTTXML === true ? ' (Lần 2)' : '');
        }
        data = [...data, itemKQTTXM];
      }

      if ((this.props.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH' || this.props.loaiDon == 'DON_TO_CAO') && this.state.nextState === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
        let checkDTVBGQ = data.filter(item => {
          if (isTTXML == true)
            return item.typeRequired == 'KQTTXM_DTVBGQ_L';
          else
            return item.typeRequired == 'KQTTXM_DTVBGQ';
        });
        if (checkDTVBGQ.length === 0) {
          let itemDTVBGQ = {
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            ten: this.props.loaiDon == 'DON_TO_CAO' ? 'Dự thảo kết luận nội dung tố cáo' : 'Dự thảo văn bản giải quyết',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: false,
            typeRequired: isTTXML == true ? 'KQTTXM_DTVBGQ_L' : 'KQTTXM_DTVBGQ',
            newFile: true
          };
          data = [...data, itemDTVBGQ];
        }
      }
    }
    this.setState({
      ListTaiLieuVanThu: data,
      ListTaiLieuVanThuShow: dataShow,
      showAttach: true
    });
  }

  onClickClose() {
    this.props.handleBack();
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      let setNgayBanHanh = {}
      if (name === 'ngayBanHanhSuggest') {
        setNgayBanHanh.ngayBanHanh = e._d
      }
      this.setState({
        ...setNgayBanHanh,
        [name]: e._d
      });
    } else {
      let setNgayBanHanh = {}
      if (name === 'ngayBanHanhSuggest') {
        setNgayBanHanh.ngayBanHanh = e
      }
      this.setState({
        ...setNgayBanHanh,
        [name]: e,
      });
    }
    this.props.handleChangeData();
  }

  handleSave() {
    this.setState({
      onSave: true
    }, async () => {
      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      let dataFileDinhKem = this.getListDataFileDinhKem('KET_THUC');
       if (dataFileDinhKem.length > 0) {
        let _taiLieuVanThuUpdate = [];
        let _taiLieuVanThu = [];
        dataFileDinhKem.forEach(item => {
          if (item.taiLieuVanThuId) {
            _taiLieuVanThuUpdate[_taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired || ''
              };
          } else {
            _taiLieuVanThu[_taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired || ''
            }
          }
        });
        await this.setState({
          taiLieuVanThuUpdate: _taiLieuVanThuUpdate,
          taiLieuVanThu: _taiLieuVanThu
        });
      }
      if ((this.state.ketQuaXLDGiaiQuyet !== 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.ketQuaXLDGiaiQuyet !== 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
        let dataFile = this.props.listTaiLieuVanThuGiaiQuyetDon ? [...this.props.listTaiLieuVanThuGiaiQuyetDon] : [];
        dataFile.forEach(item => {
          this.setState({
            taiLieuVanThuDelete: {
              id: item.taiLieuVanThuId || ''
            }
          });
        });
      }

      if (!this.state.giaoCoQuanDieuTra) {
        let dataFile = this.props.listTaiLieuVanThuGiaiQuyetDon ? [...this.props.listTaiLieuVanThuGiaiQuyetDon] : [];
        dataFile.forEach(item => {
          this.setState({
            taiLieuVanThuDelete: {
              id : item.taiLieuVanThuId || ''
            }
          });
        });
      }

      if (this.state.dataTaiLieuVanThuDelete && this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.setState({
            taiLieuVanThuDelete: {
              id: item || ''
            }
          });
        });
      }

      if (this.state.role === 'truongPhongGiaiQuyetDon') {
        let params = this.getParams(this.state.dataGiaiQuyetDon, this.state.id);
        if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
          params.phoPhong = true;
        } else {
          params.phoPhong = false;
        }
        if(this.state.nextState) {
          let selectedState = this.state.dataNextState.filter(state => state.type == this.state.nextState);
          params.nextState = {
            id: selectedState[0].stateId
          };

        } else {
          params.nextState = null;
        }
        if (this.state.canBoGiaiQuyet) {
          params.canBoXuLyChiDinh = {
            id: Number(this.state.canBoGiaiQuyet)
          };
        }
        params.ngayHetHanGiaiQuyet = moment(this.state.ngayHetHanGiaiQuyet).add(7, 'hours').toISOString();
        params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
        if (this.state.ketQuaXLDGiaiQuyet){
          params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet ;
        }
        if (this.state.soVanBan) {
          params.soVanBan = this.state.soVanBan;
        }
        if (this.state.ngayBanHanhSuggest) {
          params.ngayBanHanh = this.state.ngayBanHanhSuggest ? moment(this.state.ngayBanHanhSuggest).add(7, 'hours').toISOString() : null;;
        }
        if (this.state.nguoiBanHanh) {
          params.nguoiBanHanh = {
            id:  Number(this.state.nguoiBanHanh)
          };
        }
        if (this.state.ketLuanNoiDungKhieuNai) {
          params.ketLuanNoiDungKhieuNai =  this.state.ketLuanNoiDungKhieuNai;
        }
        if (this.state.phongBanChiDinh) {
          params.phongBanGiaiQuyet = {
            id: Number(this.state.phongBanChiDinh)
          };
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      } else if(this.state.role === 'truongPhongKiemTraDeXuat') {
        let params = this.getParams(this.state.dataGiaiQuyetDon, this.state.id);
        if (this.state.nextState) {
          let selectedState = this.state.dataNextState.filter(state => state.type === this.state.nextState);
          params.nextState = {
            id: selectedState[0].stateId
          };
        } else {
          params.nextState = null;
        }
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoGiaiQuyet)
        };
        params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      } else {
        let params = this.getParams(this.state.dataGiaiQuyetDon, this.state.id);
        if(this.state.nextState) {
          let selectedState = this.state.dataNextState.filter(state => state.type === this.state.nextState);
          params.nextState = {
            id: selectedState[0].stateId
          };
        } else {
          params.nextState = null;
        }
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoGiaiQuyet)
        };
        params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      }
    })
  }

  handleKetThuc(name) {
    if (this.state.khongCoCoQuanTheoDoiThucHien === true && this.state.isSoBanNganh && this.state.isThanhTraThanhPho !== true) {
      //do nothing
      Toastr('Không có đơn vị nhận theo dõi thực hiện', 'error');
      return;
    } else {
      this.setState({
        onSave: false
      },() => {
        if (this.validateSubmitForm()) {
          this.setState({
            btnLoading: true
          });
          let dataFileDinhKem = this.getListDataFileDinhKem('KET_THUC');
          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.forEach(item => {
              if (item.taiLieuVanThuId) {
                let state = this.state;
                state.taiLieuVanThuUpdate[state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(this.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired || ''
                }
                this.setState({state})
              } else {
                let state = this.state;
                state.taiLieuVanThu[state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(this.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired || ''
                }
                this.setState({state})
              }
            });
          }
          let state = this.state;
          if ((this.state.ketQuaXLDGiaiQuyet !== 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.ketQuaXLDGiaiQuyet !== 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
            let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ];
            dataFile.forEach(item => {
                state.taiLieuVanThuDelete = {
                  id: item.taiLieuVanThuId
                }
            });
          }
          if (!this.state.giaoCoQuanDieuTra) {
            let dataFile = this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra ? [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra] : [];
            dataFile.map(item => {
              this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }
          if (this.state.dataTaiLieuVanThuDelete && this.state.dataTaiLieuVanThuDelete.length > 0) {
            this.state.dataTaiLieuVanThuDelete.forEach(item => {
                state.taiLieuVanThuDelete = {
                  id: item
                }
            });
          }
          this.setState(state);
          let _params = this.getParams();
          let coQuanQuanLyId = this.props.dataGiaiQuyet && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId ? this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId : {};
          let params = {};
          let msgName = '';
          let coQuanQuanLyNguoiDungId = this.state.coQuanQuanLyNguoiDung && this.state.coQuanQuanLyNguoiDung.id;

          if(this.state.isSoBanNganh && this.state.donViTheoDoiThucHien !== coQuanQuanLyId && !this.state.isThanhTraThanhPho && this.state.donViTheoDoiThucHien !== coQuanQuanLyNguoiDungId) {
            if (this.props.tuGiaiQuyet) {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(this.props.thongTinGiaiQuyetDonId)
                },
                phongBanGiaiQuyet: {
                  id: Number(this.state.donViTheoDoiThucHien)
                },
                actionType: 'QGD_GIAO_PHONG_BAN_KHAC_TDTH'
              };
              params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhDinhChi;
              if (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;
              }
            } else {
              let selectedState = this.props.dataNextStates.filter(state => state.type == this.state.nextState);
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(this.props.thongTinGiaiQuyetDonId),
                },
                phongBanGiaiQuyet: {
                  id: Number(this.state.donViTheoDoiThucHien)
                },
                nextState: {
                  id: Number(selectedState[0].stateId),
                }
              };
              params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhDinhChi;
              if (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;
              }
            }
            msgName = 'gqdChuyenTheoDoi';
          } else if ((this.state.nextState === 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH' || this.state.nextState === "CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN") && this.state.donViTheoDoiThucHien !== coQuanQuanLyNguoiDungId) {
            let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
            let tttp = 'CQQL_THANH_TRA_THANH_PHO';
            let isThanhTraThanhPho = ThamSo.find(state => state.ten === tttp)
            let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
            if (isThanhTraThanhPho && isThanhTraThanhPho.giaTri === userInfo.donViId) {
              let stateKetThuc = 8;
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(this.props.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: stateKetThuc
                }
              };
              msgName = 'gqdLuuHoSo';
            } else {
              if (this.state.coQuanTheoDoiThucHien) {
                _params.donViTheoDoiThucHien = {
                  id: this.state.coQuanTheoDoiThucHien.coQuanQuanLyId
                };
              }
              let selectedState = this.props.dataNextStates.filter(state => state.type == 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN');

              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(this.props.thongTinGiaiQuyetDonId)
                },
                donViTheoDoiThucHien: {
                  id: this.state.coQuanTheoDoiThucHien.coQuanQuanLyId
                },
                nextState: {
                  id: Number(selectedState[0].stateId)
                }
              };
              msgName = 'gqdChuyenTheoDoi';
            }
            params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhDinhChi;
            if (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
              params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;
            }
          } else {
            if (this.props.tuGiaiQuyet) {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(this.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'QGD_TU_TTXM'
              };
            }
            else if (this.state.donViTheoDoiThucHien === coQuanQuanLyNguoiDungId && this.state.nextState === "CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH") {
              let selectedState = this.props.dataNextStates.find(state => state.type === "KET_THUC");
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(this.props.thongTinGiaiQuyetDonId),
                },
                nextState: {
                  id: Number(selectedState.stateId),
                }
              };
              msgName = 'gqdLuuHoSo';
            } else {
              let selectedState = this.props.dataNextStates.filter(state => state.type == this.state.nextState);
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(this.props.thongTinGiaiQuyetDonId),
                },
                nextState: {
                  id: Number(selectedState[0].stateId),
                }
              };
            }
            msgName = 'gqdLuuHoSo';
          }
          this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
            this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
              this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
                this.props.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        }
      })
    }
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    });
    if (name === 'giaoCoQuanDieuTra') {
      this.checkFileCoQuanDieuTra();
    }
    this.props.handleChangeData();
  }

  handleGiaiQuyetDon(type) {
    if(this.validateSubmitForm()) {
      this.setState({
        btnLoading: true
      });
      let selectedState = this.state.dataNextState.filter(state => state.type === this.state.nextState);
      if(this.state.role === 'truongPhongGiaiQuyetDon') {
        if (this.state.nextState === 'GQDTTTXM_GIAO_PHONG_CUNG_CAP') {
          let _params = getParams(this.state.dataGiaiQuyetDon, this.state.id);
          _params.ngayHetHanGiaiQuyet = moment(this.state.ngayHetHanGiaiQuyet).add(7, 'hours').toISOString();
          let params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet,
            phongBanGiaiQuyet:{
              id: Number(this.state.phongBanChiDinh)
            }
          };
          /* if (this.state.canBoGiaiQuyet) {
            params.canBoXuLyChiDinh = {
              id: Number(this.state.canBoGiaiQuyet)
            };
          } */
          this.props.updateGiaiQuyetDon(_params, params, 'gqdGiaoViec');
        } else if (this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG') {
          let _params = getParams(this.state.dataGiaiQuyetDon, this.state.id);
          _params.ngayHetHanGiaiQuyet = moment(this.state.ngayHetHanGiaiQuyet).add(7, 'hours').toISOString();
          let params = {
            canBoXuLyChiDinh: {
              id: Number(this.state.canBoGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            phoPhong: true,
            yKienGiaiQuyet: this.state.yKienGiaiQuyet,
            phongBanGiaiQuyet:{
              id: Number(this.state.coQuanQuanLyNguoiDung.id)
            }
          };
          this.props.updateGiaiQuyetDon(_params, params, 'gqdGiaoViec');
        } else {
          let _params = getParams(this.state.dataGiaiQuyetDon, this.state.id);
          _params.ngayHetHanGiaiQuyet = moment(this.state.ngayHetHanGiaiQuyet).add(7, 'hours').toISOString();
          let params = {
            canBoXuLyChiDinh: {
              id: Number(this.state.canBoGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet,
          };
          this.props.updateGiaiQuyetDon(_params, params, 'gqdGiaoViec');
        }
      } else if(this.state.role === 'truongPhongKiemTraDeXuat') {

        let params = {
          canBoXuLyChiDinh: {
            id: Number(this.state.canBoGiaiQuyet)
          },
          thongTinGiaiQuyetDon: {
            id: Number(this.state.thongTinGiaiQuyetDonId)
          },
          nextState: {
            id: Number(selectedState[0].stateId)
          },
          yKienGiaiQuyet: this.state.yKienGiaiQuyet
        };
        this.props.postGiaiQuyetDon(params, 'gqdGiaoViec');
      } else {
        let params = {
          canBoXuLyChiDinh: {
            id: Number(this.state.canBoGiaiQuyet)
          },
          thongTinGiaiQuyetDon: {
            id: Number(this.state.thongTinGiaiQuyetDonId)
          },
          nextState: {
            id: Number(selectedState[0].stateId)
          },
          yKienGiaiQuyet: this.state.yKienGiaiQuyet
        };
        this.props.postGiaiQuyetDon(params, 'gqdGiaoViec');
      }
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        [name]: true
      })
    }
  }

  closeDialog(name) {
    this.setState({
      [name]: false
    })
  }

  onSuccess(name) {
    if (this.state.nextState === "CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH" || this.state.nextState === 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN') {
      this.closeDialog(name);
      this.handleKetThuc(name);
    } else {
      this.closeDialog(name);
      this.truongPhongGQD();
    }
  }

  closeDialogConfirm() {
    this.setState({
      open: false,
      ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
    })
  }

  onSuccessDialogConfirm() {
    this.setState({
      open: false,
      ketQuaXLDGiaiQuyet: this.state.valueKetQua
    });
  }

  saveTruongPhongGQD(){
    this.setState({
      onSave: true
    }, () => {
      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      let dataFileDelete = [];
      if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
        if (this.state.dataFileDinhKem && Array.isArray(this.state.dataFileDinhKem.data)) {
          this.state.dataFileDinhKem.data.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' ? 'XU_LY_DON' : loaiQuyTrinh,
                buocGiaiQuyet: buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });

          if (Array.isArray(this.state.dataTaiLieuVanThuDelete)) {
            this.state.dataTaiLieuVanThuDelete.map(item => {
              this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }
        }
      } else {
        let data = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
        data.filter(state => {
          return state.required && state.typeRequired == 'BC_KQTTXM_GQKN'
        }).map((item) => {
          dataFileDelete[dataFileDelete.length] = {
            id: item.taiLieuVanThuId
          }
        });
      }

      let params = getParams(this.state.dataGiaiQuyetDon, this.state.id);
      let isQuaHan  = (this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0) ? true : false;
      if (isQuaHan == true) {
        params.lyDoQuaHan = this.state.lyDoQuaHan;
      }
      if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
        params.phoPhong = true;
      } else {
        params.phoPhong = false;
      }
      let selectedState = this.state.dataNextState.filter(state => {
        return state.type == this.state.nextState
      });

      if (selectedState.length > 0) {
        params.nextState = {
          id: selectedState[0].stateId
        }
      }

      if (this.state.canBoGiaiQuyet) {
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoGiaiQuyet)
        };
      } else {
        params.canBoXuLyChiDinh = null
      }

      if (this.state.ketLuanNoiDungKhieuNaiGiaoTTXM) {
        params.ketLuanNoiDungKhieuNaiGiaoTTXM = this.state.ketLuanNoiDungKhieuNaiGiaoTTXM
      } else {
        params.ketLuanNoiDungKhieuNaiGiaoTTXM = null
      }

      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet ? this.state.yKienGiaiQuyet : '';
      params.noiDung = this.state.noiDung ? this.state.noiDung : '';
      if (this.state.phongBanChiDinh) {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanChiDinh)
        };
      }
      if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      } else {
        this.deleteTaiLieuVanThu(dataFileDelete, () => {
          this.props.saveGiaiQuyetDon(params, 'gqdLuu');
        });
      }
    })
  }

  truongPhongGQD(){
    this.setState({
      onSave: false
    }, () => {
      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        let dataFileDelete = [];
        if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          if (this.state.dataFileDinhKem && Array.isArray(this.state.dataFileDinhKem.data)) {
            this.state.dataFileDinhKem.data.map((item, i) => {
              if (item.taiLieuVanThuId) {
                this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(this.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(this.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' ? 'XU_LY_DON' : loaiQuyTrinh,
                  buocGiaiQuyet: buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });

            if (Array.isArray(this.state.dataTaiLieuVanThuDelete)) {
              this.state.dataTaiLieuVanThuDelete.map(item => {
                this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
                  id: item
                };
              });
            }
          }
        } else {
          let data = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
          if (this.props.donInfo && this.props.donInfo.laTTXMLai) {
            data.filter(state => {
              return state.required && state.typeRequired == 'BC_KQTTXM_GQKN_L'
            }).map((item) => {
              dataFileDelete = [...dataFileDelete, { id: item.taiLieuVanThuId }];
            });
          } else {
            data.filter(state => {
              return state.required && state.typeRequired == 'BC_KQTTXM_GQKN'
            }).map((item) => {
              dataFileDelete = [...dataFileDelete, { id: item.taiLieuVanThuId }];
            });
          }
        }
        let _params = getParams(this.state.dataGiaiQuyetDon, this.state.id);
        let selectedState = this.state.dataNextState.filter(state => {
          return state.type == this.state.nextState
        });
        let msgName = '';
        let params = {};
        let isQuaHan  = (this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0) ? true : false;
        if (selectedState.length > 0) {
          _params.nextState = {
            id: selectedState[0].stateId
          }
        }

        if (this.state.canBoXuLyChiDinh) {
          _params.canBoXuLyChiDinh = {
            id: Number(this.state.canBoGiaiQuyet)
          };
        } else {
          _params.canBoXuLyChiDinh = null
        }

        if (this.state.ketLuanNoiDungKhieuNaiGiaoTTXM) {
          _params.ketLuanNoiDungKhieuNaiGiaoTTXM = this.state.ketLuanNoiDungKhieuNaiGiaoTTXM
        } else {
          _params.ketLuanNoiDungKhieuNaiGiaoTTXM = null
        }

        _params.yKienGiaiQuyet = this.state.yKienGiaiQuyet ? this.state.yKienGiaiQuyet : (this.state.noiDung ? this.state.noiDung : '');
        _params.noiDung = this.state.noiDung ? this.state.noiDung : '';

        if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.noiDung
          }
          if (isQuaHan == true) {
            params.lyDoQuaHan = this.state.lyDoQuaHan;
          }
          msgName = 'gqdTraBaoCao';
        } else if (this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN'){
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          };
          msgName = 'gqdTraDonThanhCong';
        } else if (this.state.nextState === "NHANTTXM_GIAO_PHONG_CUNG_CAP") {
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            phongBanGiaiQuyet: {
              id: Number(this.state.phongBanChiDinh)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          };
          if (this.state.canBoGiaiQuyet) {
            params.canBoXuLyChiDinh = {
              id: Number(this.state.canBoGiaiQuyet)
            };
          }
          msgName = 'gqdGiaoViec';
        } else if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
          params = {
            canBoXuLyChiDinh: {
              id: Number(this.state.canBoGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            phoPhong: true,
            phongBanGiaiQuyet: {
              id: Number(this.state.coQuanQuanLyNguoiDung.id)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          };
          msgName = 'gqdGiaoViec';
        } else {
          params = {
            canBoXuLyChiDinh: {
              id: Number(this.state.canBoGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          };
          msgName = 'gqdGiaoViec';
        }
        if (this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
            this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
              this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
                this.props.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        } else {
          this.deleteTaiLieuVanThu(dataFileDelete, () => {
            this.props.updateGiaiQuyetDon(_params, params, msgName);
          });
        }
      }
    })
  }

  onFileChange(data, type) {
    let dataFileDinhKem = {...this.state.dataFileDinhKem};
    switch (type) {
      case 'BAO_CAO_KET_QUA_TTXM':
        dataFileDinhKem.baoCaoKetQuaTTXM = data;
        break;
      case 'QUYET_DINH_GIAI_QUYET':
        dataFileDinhKem.quyetDinhGiaiQuyet = data;
        let fileQD = data.filter(item => item.typeRequired === 'QDGQ_TTT');
        if ( !isEmpty(fileQD) && fileQD[0].unSetNgayBanHanh) {
          this.setState ({
            ngayBanHanhSuggest: fileQD[0].ngayQuyetDinh,
            soVanBan: fileQD[0].soQuyetDinh
          });
        }
        break;
      case 'GIAO_CO_QUAN_DIEU_TRA':
        dataFileDinhKem.giaoCoQuanDieuTra = data;
        break;
      case 'GIA_HAN':
        dataFileDinhKem.giaHan = data;
        break;
      default:
        dataFileDinhKem.data = data;
    }
    this.setState ({
      dataFileDinhKem: dataFileDinhKem
    });
    this.props.handleChangeData();
  }

  getListDataFileDinhKem(type) {
    if (type === 'GIAO_TTXM') {
      return this.state.dataFileDinhKem.data;
    }
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;
    if (Data.baoCaoKetQuaTTXM.length > 0) {
      Data.baoCaoKetQuaTTXM.forEach(item => {
        dataFileDinhKem[dataFileDinhKem.length] = item;
      });
    }

    if (Data.data && Data.data.length > 0) {
      Data.data.forEach(item => {
        dataFileDinhKem[dataFileDinhKem.length] = item;
      });
    }

    if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
      Data.quyetDinhGiaiQuyet.forEach(item => {
        dataFileDinhKem[dataFileDinhKem.length] = item;
      });
    }

    if (Data.giaoCoQuanDieuTra && Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
      Data.giaoCoQuanDieuTra.forEach(item => {
        dataFileDinhKem[dataFileDinhKem.length] = item;
      });
    }

    if (Data.giaHan && Data.giaHan.length > 0 && this.state.giaHanGiaiQuyet) {
      Data.giaHan.forEach(item => {
        dataFileDinhKem[dataFileDinhKem.length] = item;
      });
    }

    return dataFileDinhKem;
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
    let params = getParams(dataGiaiQuyetDon, this.state.id);
    if (this.state.giaoCoQuanDieuTra) {
      params.giaoCoQuanDieuTra = true;
      if (this.state.coQuanDieuTra) {
        params.coQuanDieuTra =  {
          id: Number(this.state.coQuanDieuTra)
        };
      }
      params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
      params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);
      if (this.state.khoiTo) {
      params.khoiTo = true;
      params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
      params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
      } else {
        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }
    } else {
      params.giaoCoQuanDieuTra = false;
      params.coQuanDieuTra =  null
      params.soVuGiaoCoQuanDieuTra = 0;
      params.soDoiTuongGiaoCoQuanDieuTra = 0;

      params.khoiTo = false;
      params.soVuBiKhoiTo = 0;
      params.soDoiTuongBiKhoiTo = 0;
    }
    if (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      params.quyetDinhGiaiQuyetKhieuNai = true;
      params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

      params.soVanBan = this.state.soVanBan || '';
      params.ngayBanHanh = this.state.ngayBanHanhSuggest ? moment(this.state.ngayBanHanhSuggest).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;
      params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;

      if (this.props.loaiDon === 'DON_KHIEU_NAI') {
        params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);

        if (Number(this.state.soLanGiaiQuyetLai) > 1) {
          params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 || null;
        } else {
          params.ketQuaGiaiQuyetLan2 = null;
        }

        if ((this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' && Number(this.state.soLanGiaiQuyetLai) > 1)) {
          params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
        } else {
          params.noiDungKetLuanGiaiQuyetLai = '';
        }
      }

      params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
      params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
      params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
      params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

      params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
      params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
      params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
      params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
      params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
    } else {
      params.quyetDinhGiaiQuyetKhieuNai = false;

      params.soLanGiaiQuyetLai = 0;
      params.ketQuaGiaiQuyetKhac = '';

      params.ketQuaGiaiQuyetLan2 = null;
      params.noiDungKetLuanGiaiQuyetLai = '';

      params.tienPhaiThuNhaNuocQDGQ = 0;
      params.tienPhaiTraCongDanQDGQ = 0;
      params.datPhaiThuNhaNuocQDGQ = 0;
      params.datPhaiTraCongDanQDGQ = 0;

      params.soVuGiaiQuyetKhieuNai = 0;
      params.ketLuanNoiDungKhieuNai = null;
      params.tongSoNguoiXuLyHanhChinh = 0;
      params.soNguoiDaBiXuLyHanhChinh = 0;

      params.soNguoiDuocTraLaiQuyenLoi = 0;
    }
    if (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
      params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
      params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      params.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;
    }
    let coQuanQuanLyId = this.props.dataGiaiQuyet && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId ? this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId : {};
    if (!this.state.isSoBanNganh || this.state.donViTheoDoiThucHien === coQuanQuanLyId || this.state.isThanhTraThanhPho || this.state.ketQuaThucHienTheoDoi) {
      if (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        params.theoDoiThucHien = true;
        params.hinhThucTheoDoi =  this.state.hinhThucTheoDoi || null;
        if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi === 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
          params.coQuanTheoDoi = this.state.coQuanTheoDoi || null
        } else {
          params.coQuanTheoDoi = null;
        };
        params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi || null;
        params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac || '';
        params.tienPhaiThuNhaNuoc = Number(this.state.tienPhaiThuNhaNuoc);
        params.datPhaiThuNhaNuoc = Number(this.state.datPhaiThuNhaNuoc);
        params.tienPhaiTraCongDan = Number(this.state.tienPhaiTraCongDan);
        params.datPhaiTraCongDan = Number(this.state.datPhaiTraCongDan);
        params.tienDaThuNhaNuoc = Number(this.state.tienDaThuNhaNuoc);
        params.datDaThuNhaNuoc = Number(this.state.datDaThuNhaNuoc);
        params.tienDaTraCongDan = Number(this.state.tienDaTraCongDan);
        params.datDaTraCongDan = Number(this.state.datDaTraCongDan);
      } else {
        params.theoDoiThucHien = false;
        params.ketQuaThucHienKhac = '';
        params.hinhThucTheoDoi = null;
        params.coQuanTheoDoi = null
        params.ketQuaThucHienTheoDoi = null;
        params.tienDaThuNhaNuoc = 0;
        params.datDaThuNhaNuoc = 0;
        params.tienDaTraCongDan = 0;
        params.datDaTraCongDan = 0;
        params.tienPhaiThuNhaNuoc = 0;
        params.datPhaiThuNhaNuoc = 0;
        params.tienPhaiTraCongDan = 0;
        params.datPhaiTraCongDan = 0;
      }
    } else {
      params.theoDoiThucHien = false;
      params.ketQuaThucHienKhac = '';
      params.hinhThucTheoDoi = null;
      params.coQuanTheoDoi = null
      params.ketQuaThucHienTheoDoi = null;
      params.tienDaThuNhaNuoc = 0;
      params.datDaThuNhaNuoc = 0;
      params.tienDaTraCongDan = 0;
      params.datDaTraCongDan = 0;
      params.tienPhaiThuNhaNuoc = 0;
      params.datPhaiThuNhaNuoc = 0;
      params.tienPhaiTraCongDan = 0;
      params.datPhaiTraCongDan = 0;
    }
    params.ketQuaXLDGiaiQuyet = (this.state.tienDoDoiThoai === 'KHONG_DOI_THOAI' && this.state.ketQuaXLDGiaiQuyet) ? this.state.ketQuaXLDGiaiQuyet : null;
    if (this.state.loaiDon === 'DON_KHIEU_NAI' || this.state.loaiDon === 'DON_TO_CAO') {
      if (this.state.doiThoai) {
        params.doiThoai = true;
        params.thoiGianDoiThoai = moment(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString();
        params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
        params.noiDungDoiThoai = this.state.noiDungDoiThoai;
      } else {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
      }
    } else {
      params.doiThoai = false;
      params.thoiGianDoiThoai = null;
      params.diaDiemDoiThoai = '';
      params.noiDungDoiThoai = '';
    }

    params.donViThamTraXacMinh = null;
    params.ngayHetHanTTXM = null;
    params.yKienGiaiQuyet = '';

    params.don = {
      id: Number(this.state.id)
    }
    params.ketLuanNoiDungKhieuNaiGiaoTTXM = this.state.ketLuanNoiDungKhieuNaiGiaoTTXM || null;
    return params;
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });
    switch(type) {
      case 'BAO_CAO_KET_QUA_TTXM':
        let dataFileDinhKem = this.state.dataFileDinhKem;
        dataFileDinhKem.baoCaoKetQuaTTXM = data;
        this.setState ({
          dataFileDinhKem: dataFileDinhKem
        });
        break;
      case 'QUYET_DINH_GIAI_QUYET':
        dataFileDinhKem.quyetDinhGiaiQuyet = data;
        this.setState ({
          dataFileDinhKem: dataFileDinhKem
        });
        break;
      case 'GIAO_CO_QUAN_DIEU_TRA':
        dataFileDinhKem.giaoCoQuanDieuTra = data;
        this.setState ({
          dataFileDinhKem: dataFileDinhKem
        });
        break;
      case 'GIA_HAN':
        dataFileDinhKem.giaHan = data;
        this.setState ({
          dataFileDinhKem: dataFileDinhKem
        });
        break;
      default:
        dataFileDinhKem.data = data;
        this.setState ({
          dataFileDinhKem: dataFileDinhKem
        });
    }
    this.setState ({
      dataFileDinhKem: data
    });
    this.props.handleChangeData();
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  inPhieuGiaoTTXMKhieuNai() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    let tenCoQuan = this.state.tenCoQuan.filter(state => state.coQuanQuanLyId === this.state.donViThamTraXacMinh);
    let URL = String(API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKhieuNai?"
    + "tenCoQuanThuLyGQKN=" + (this.props.coQuanDangQuyetInfo ? this.props.coQuanDangQuyetInfo.ten : '')
    + "&tenCoQuanDuocGiaoNhiemVuXM=" + (tenCoQuan.length > 0 ? tenCoQuan[0].ten : '')
    + "&donViXuLyId=" + userInfo.donViId
    + "&donId=" + this.state.thongTinGiaiQuyetDonId
    + "&thoiGianBaoCaoKetQuaTTXM=" + moment(this.state.ngayHetHanTTXM).format('DD/MM/YYYY')
    + "&hoTenNguoiKhieuNai=" + (this.props.listNguoiDungDon ? this.props.listNguoiDungDon[0].hoVaTen : '')
    + "&noiDungTTXM=" + this.props.noiDungDonThu;
    window.open(URL, "_self");
  }

  inPhieuGiaoTTXMToCao() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    let tenCoQuan = this.state.tenCoQuan.filter(state => state.coQuanQuanLyId === this.state.donViThamTraXacMinh);
    let URL = String(API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao?"
    + "tenCoQuan=" + (tenCoQuan.length > 0 ? tenCoQuan[0].ten : '')
    + "&donViXuLyId=" + userInfo.donViId
    + "&noiDungDonThu=" + this.props.noiDungDonThu
    + "&donId=" + this.state.thongTinGiaiQuyetDonId
    + "&thoiGianBaoCaoKetQuaTTXM=" + moment(this.state.ngayHetHanTTXM).format('DD/MM/YYYY')
    window.open(URL, "_self");
  }

  render() {
    let ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(state => state.giaTri == this.state.ketQuaXLDGiaiQuyet);
    let ketLuanNDKhieuNaiLabel = this.props.loaiDon === 'DON_KHIEU_NAI' ? 'Kết luận nội dung khiếu nại' : (this.props.loaiDon === 'DON_TO_CAO' ? 'Kết luận nội dung tố cáo' : "Kết luận nội dung kiến nghị phản ánh");
    let coQuanQuanLyId = this.props.dataGiaiQuyet && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo ? this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId : '';
    let lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    let lb3 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
    let lbGuiTTXM = 'Gửi báo cáo '+lb1;
    let txtTuGQ = 'Tự giải quyết';
    let lbTraTTXM = 'Trả đơn do chuyển '+lb1+' không đúng';
    let isQuaHan  = (this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0) ? true : false;
    let coQuanQuanLyNguoiDungId = this.props.coQuanQuanLyNguoiDung && this.props.coQuanQuanLyNguoiDung.id;
    return (
      <section className="wrap-block">
        <ShowIf condition={this.state.role === 'truongPhongTTXM'}>
          <NhiemVuTTXM
            donViGiaoThamTraXacMinh={this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo}
            ngayBatDauTTXM={this.state.dataGiaiQuyetDon.ngayBatDauTTXM}
            yKienCuaDonViGiaoTTXM = {this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM}
            ngayHetHanTTXM={this.state.dataGiaiQuyetDon.ngayHetHanTTXM}
            donInfo={this.props.donInfo}
          />
        </ShowIf>
        <ShowIf condition={this.state.role === 'truongPhongKiemTraDeXuat'}>
          <ThongTinYeuCauKiemTraDeXuat
            listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon}
            {...this.props.dataKiemTraDeXuat}
            donInfo={this.props.donInfo}
            />
        </ShowIf>
        <ShowIf condition={this.props.alias === "TruongPhongTTXMAction"}>
          <div className="wrap-big-line pt5 pb20">
            <span className="big-border"></span>
          </div>
        </ShowIf>
        {
          this.props.alias === 'TruongPhongTTXMAction' && this.state.nextState === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' ?
            <h2 className="title-14 mb15">Báo cáo kết quả xác minh{lb2}</h2>
          :
            <h2 className="title-14 mb15">Thông tin giải quyết</h2>
        }
        <ShowIf condition={this.props.alias !== 'TruongPhongTTXMAction'}>
          <form className="form-action">
            <div className="row pl10 pr10">
              <ShowIf condition={this.props.loaiDon === 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet && this.props.roleGQ === 'truongPhongGiaiQuyetDon'}>
                <div className="col-25">
                  <label className="pt-label">
                    <span className="val-title-bold">Gia hạn đến ngày:</span>
                    <span className="val-content pt17">{this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}</span>
                  </label>
                </div>
              </ShowIf>
              <ShowIf condition={this.props.roleGQ === 'truongPhongKiemTraDeXuat'}>
                <div className="col-100 mb10">
                  <span className="val-title-inline-bold">Phòng: &nbsp;</span>
                  <span className='val-content-inline'>{typeof this.state.coQuanQuanLyNguoiDung != 'undefined' ? this.state.coQuanQuanLyNguoiDung.ten : ''}</span>
                </div>
              </ShowIf>
              <ShowIf condition={!this.state.showTienDoGiaiQuyet}>
                <DropDownMulipleUse
                  onRef={select => (this.select = select)}
                  className="col-25"
                  donId={this.state.id}
                  require
                  isValid={this.state.validate}
                  data={this.state.dataNextState}
                  keyName='type'
                  disable={ this.state.ketQuaXLDGiaiQuyet !== '' ? true : false }
                  valueName='tenVietTat'
                  label="Hướng giải quyết"
                  bindValidator={this}
                  name="huongGiaiQuyet"
                  selectedValue={this.state.nextState}
                  onChange={this.onChange.bind(this, 'nextState')}/>
                </ShowIf>
                <ShowIf condition={this.state.ketQuaXLDGiaiQuyet && this.state.showTienDoGiaiQuyet}>
                  <p className="attach-file-description mb10 pl5 pr5">Hướng giải quyết</p>
                  <Text className="col-25" label='' value={txtTuGQ}/>
                </ShowIf>

                <ShowIf condition={this.state.nextState === 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH' || this.state.nextState === "CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN"}>
                  <div className="col-100">
                <div className="col-100 no-gutter pt5 pb15">
                  <span className="line-border"></span>
                </div>
                <div className="col-100 no-gutter">
                  <h2 className="title-12 mb15">Báo cáo kết quả xác minh{lb2}</h2>
                  <div className="col-100 no-gutter">
                    <div className="col-100 no-gutter pb5">
                      <ShowIf condition={this.state.allowAttach}>
                        <ContainerFileDinhKem name="BaoCaoKQTTXM" onSave={this.state.onSave} loaiDon={this.props.loaiDon} phanLoaiQuyTrinh='BAO_CAO_KET_QUA_TTXM' label="Danh sách văn bản xử lý" tTXMText='TTXM_TTT' tTXMRequired={true} bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                      </ShowIf>
                    </div>
                    <ShowIf condition={this.props.loaiDon === 'DON_TO_CAO' && this.state.giaHanGiaiQuyet}>
                      <div className="col-100 no-gutter mt5">
                        <div className="row pl10 pr10">
                          <div className="col-100 pb15">
                            <span className="line-border"></span>
                          </div>
                          <p className="txt-bold txt-upper mb10 pl5 pr5">Gia hạn giải quyết tố cáo</p>
                          <Text red={true} className="col-25 mb10" label="Gia hạn đến ngày:" value={this.state.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                          <TextMessage className="col-100 mb5" label="Lý do gia hạn:" value={this.state.lyDoGiaHanGiaiQuyet}/>
                          <div className="col-100 pb5">
                          </div>
                        </div>
                      </div>
                    </ShowIf>
                  </div>
                </div>
                <div className="col-100 no-gutter">
                  <div className="col-100 no-gutter pt5 pb15">
                    <span className="line-border"></span>
                  </div>
                  <h2 className="title-12 mb10">Tiến độ giải quyết</h2>
                  <div className="row pl10 pr10">
                    <p className="attach-file-description mb10 pl5 pr5">Tiến độ giải quyết cho biết giai đoạn giải quyết hiện tại của đơn</p>
                    <ShowIf condition={!this.state.showTienDoGiaiQuyet}>
                      <ShowIf condition={this.state.tienDoDoiThoai === 'KHONG_DOI_THOAI'}>
                        <DropDownMulipleUse disable={this.state.ketQuaXLDGiaiQuyet !== '' ? true : false} name="tienDoGiaiQuyet" confirm={true} label='' className="col-25" data={this.state.dataKetQuaGiaiQuyetDon} keyName='giaTri' valueName='ten' selectedValue={this.state.ketQuaXLDGiaiQuyet} onChange={this.onChange.bind(this, 'ketQuaXLDGiaiQuyet')}/>
                      </ShowIf>
                    </ShowIf>
                    <ShowIf condition={this.state.showTienDoGiaiQuyet}>
                      <Text className="col-25" label='' value={ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : ''}/>
                    </ShowIf>
                  </div>

                  <ShowIf condition={this.props.loaiDon === 'DON_KHIEU_NAI'}>
                    <div className="col-100 no-gutter">
                      <ShowIfCheck label="Đối thoại" onChange={this.handleCheck.bind(this, 'doiThoai')} checked={this.state.doiThoai}>
                        <div className="col-100 no-gutter mt5">
                          <h2 className="title-12 mb15">Đối thoại</h2>
                          <div className="row pl10 pr10">
                            <DatePicker className="col-25" require label="Thời gian đối thoại" bindValidator={this} channel="formTaoDon" value={this.state.thoiGianDoiThoai} onChange={this.handleChangeDate.bind(this, 'thoiGianDoiThoai')} name="datepickerThoiGianDoiThoai"/>
                            <Input className="col-75" require bindValidator={this} channel="formTaoDon" label="Địa điểm" value={this.state.diaDiemDoiThoai} onChange={this.onChange.bind(this, 'diaDiemDoiThoai')} name="inputDiaDiem"/>
                            <TextArea className='col-100' require bindValidator={this} channel="formTaoDon" name="ketQuaDoiThoai" label='Nội dung, kết quả đối thoại' value={this.state.noiDungDoiThoai} onChange={this.onChange.bind(this, 'noiDungDoiThoai')}/>
                          </div>
                        </div>
                      </ShowIfCheck>
                    </div>
                    <div className="col-100 no-gutter pt5 pb15">
                      <span className="line-border"></span>
                    </div>
                  </ShowIf>
                </div>
                <div className="col-100 no-gutter">
                  <ShowIf condition={this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
                    <div className="col-100 no-gutter mb5 mt5">
                      <ShowIf condition={this.props.loaiDon === 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET'}><h2 className="title-12 mb15">Quyết định giải quyết khiếu nại</h2></ShowIf>
                      <ShowIf condition={this.props.loaiDon === 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet !== 'DA_CO_QUYET_DINH_GIAI_QUYET'}><h2 className="title-12 mb15">Quyết định đình chỉ</h2></ShowIf>
                      <ShowIf condition={this.props.loaiDon === 'DON_TO_CAO'}><h2 className="title-12 mb15">Quyết định giải quyết tố cáo</h2></ShowIf>
                      <ShowIf condition={this.props.loaiDon !== 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI'}><h2 className="title-12 mb15">Văn bản giải quyết kiến nghị, phản ánh</h2></ShowIf>
                      <div className="row pl10 pr10">
                        <Input triggeOnBlur={true} className="col-25" name="inputSoVanBan" label="Số văn bản" bindValidator={this} channel="formTaoDon" require value={this.state.soVanBan} onChange={this.onChange.bind(this, 'soVanBan')} maxLength={255} />
                        <DatePicker className="col-25" label="Ngày ban hành" endDate={new Date()} name="inputNgayBanHanh" bindValidator={this} channel="formTaoDon" require value={this.state.ngayBanHanhSuggest} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhSuggest')} />
                        <DropDownNguoiKy selected={this.state.nguoiBanHanh} onChange={this.onChange.bind(this, 'nguoiBanHanh')} />
                        {
                          this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' &&
                            <TextArea value={this.state.lyDoBanHanhQuyetDinhGiaiQuyet} className="areal-wrap col-100" label={`Nội dung ${this.state.gqText}`} placeholder="Nhập ..." onChange={this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet')} name="lyDoBanHanhQuyetDinhGiaiQuyet"/>
                        }
                        {
                          this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' &&
                            <TextArea value={this.state.lyDoBanHanhQuyetDinhDinhChi} bindValidator={this} channel="formTaoDon" require className="areal-wrap col-100" label="Lý do đình chỉ" placeholder="Nhập lý do" onChange={this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi')} name="lyDoBanHanhQuyetDinhDinhChi" maxLength={1000}/>
                        }
                        <ShowIf condition={this.state.allowAttach}>
                          <div className="col-100">
                            <ContainerFileDinhKem unSetNgayBanHanh quyetDinh={this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false} loaiVanBanSuggest="QDGQ_TTT" name="ThuHoiChoNN" ngayQuyetDinhSuggest={this.state.ngayBanHanh} soVanBanSuggest={this.state.soVanBan} onSave={this.state.onSave} loaiDon={this.state.loaiDon} phanLoaiQuyTrinh='QUYET_DINH_GIAI_QUYET' qDGQText='QDGQ_TTT' qDGQRequired={this.state.tTXMRequired} label="Danh sách văn bản xử lý" bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                          </div>
                        </ShowIf>
                      </div>

                      <div className="col-100 no-gutter pt10 pb20">
                        <span className="line-border"></span>
                      </div>
                      <ShowIf condition={this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
                        { this.props.donInfo.layVuViecCu === true &&
                          <div className="row pl10 pr10">
                            <DropDownChonKetQuaGiaiQuyet className='col-25' name="ketQuaGiaiQuyetLan2" require bindValidator={this} label='Kết quả giải quyết' selectedValue={this.state.ketQuaGiaiQuyetLan2} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetLan2')}/>

                            { this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' &&
                              <TextArea className='col-100' label='Lý do' require bindValidator={this} channel='formTaoDon' value={this.state.noiDungKetLuanGiaiQuyetLai} onChange={this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai')} name="noiDungKetLuanGiaiQuyetLai" maxLength={1000}/>
                            }
                          </div>
                        }
                        <div className="row pl10 pr10">
                          <InputNumber className="col-25 mb0-18" label="Số vụ" name="soVu" value={this.state.soVuGiaiQuyetKhieuNai} onChange={this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai')}/>
                          <DropDownChonKetLuanNoiDungKhieuNai require bindValidator={this} channel="formTaoDon" loaiDon={this.props.loaiDon} label={ketLuanNDKhieuNaiLabel} className="col-25" selectedValue={this.state.ketLuanNoiDungKhieuNai} onChange={this.onChange.bind(this, 'ketLuanNoiDungKhieuNai')}/>
                          <Input className="col-25 mb0-18" label="Kết quả khác" name="ketQuaKhac" value={this.state.ketQuaGiaiQuyetKhac} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetKhac')}/>
                        </div>
                        <div className="row pl10 pr10">
                          <div className="col-50 no-gutter mb20">
                            <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                            <Input className="col-50 mb0-18" type="sdt" name="tienPhaiThuNhaNuocQDGQ" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ')}/>
                            <Input className="col-50 mb0-18" type="sdt" align="right" name="datPhaiThuNhaNuocQDGQ" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ')}/>
                          </div>
                          <div className="col-50 no-gutter mb20">
                            <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                            <Input className="col-50 mb0-18" type="sdt" align="right" name="tienPhaiTraCongDanQDGQ" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ')}/>
                            <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" name="datPhaiTraCongDanQDGQ" value={this.state.datPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'datPhaiTraCongDanQDGQ')}/>
                          </div>
                          <div className="col-100 no-gutter">
                            <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                            <InputNumber className="col-25" name="tongSoNguoiXuLyHanhChinh" label="Tổng số người" value={Number(this.state.tongSoNguoiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh')}/>
                            <InputNumber className="col-25" name="soNguoiDaBiXuLyHanhChinh" label="Số người đã bị xử lý" value={Number(this.state.soNguoiDaBiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh')}/>
                            <InputNumber className="col-25" name="soNguoiDuocTraLaiQuyenLoi" label="Số người được trả lại quyền lợi" value={this.state.soNguoiDuocTraLaiQuyenLoi} onChange={this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi')}/>
                          </div>
                        </div>
                        <div className="col-100 no-gutter pt5 pb15">
                          <span className="line-border"></span>
                        </div>
                      </ShowIf>
                    </div>
                  </ShowIf>
                </div>

                <ShowIf condition={(this.state.donViTheoDoiThucHien === coQuanQuanLyId || this.state.donViTheoDoiThucHien === coQuanQuanLyNguoiDungId || this.state.isThanhTraThanhPho || this.props.noRule) && this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
                  <div className="col-100 no-gutter">
                    <div className="col-100 no-gutter mt5 pb20">
                      <h2 className="title-12 mb15">Theo dõi thực hiện</h2>
                      <div className="row pl10 pr10 mb20">
                        <ShowIf condition={this.state.hinhThucTheoDoi === 'GIAO_CO_QUAN_KHAC_THEO_DOI'}>
                          <DropDownMulipleUse className="col-25 mb0-18" label="Cơ quan theo dõi" bindValidator={this} selectedValue={this.state.coQuanTheoDoi} onChange={this.onChange.bind(this, 'coQuanTheoDoi')} name='coQuanTheoDoi' data={this.state.dataCoQuanTheoDoi} keyName='giaTri' valueName='ten'/>
                        </ShowIf>
                      </div>
                      <div className="row pl10 pr10 mb20">
                        <DropDownChonKetQuaThucHien className="col-25 mb0-18" bindValidator={this} require selectedValue={this.state.ketQuaThucHienTheoDoi} onChange={this.onChange.bind(this, 'ketQuaThucHienTheoDoi')}/>
                        <Input className="col-25 mb0-18" label="Kết quả thực hiện khác" value={this.state.ketQuaThucHienKhac} onChange={this.onChange.bind(this, 'ketQuaThucHienKhac')} name='ketQuaThucHienKhac'/>
                      </div>
                      <div className="row pl10 pr10">
                        <div className="col-100 no-gutter mb20">
                          <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                          <Input className="col-25 mb0-18" name="tienPhaiThuNhaNuoc" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuoc')}/>
                          <Input className="col-25 mb0-18" type="sdt" align="right" name="datPhaiThuNhaNuoc" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuoc')}/>
                          <Input className="col-25 mb0-18" name="tienDaThuNhaNuoc" type="sdt" align="right" label="Đã thu tiền (đ)" value={this.state.tienDaThuNhaNuoc} onChange={this.onChange.bind(this, 'tienDaThuNhaNuoc')}/>
                          <Input className="col-25 mb0-18" name="datDaThuNhaNuoc" type="sdt" align="right" label="Đã thu đất (m2)" value={this.state.datDaThuNhaNuoc} onChange={this.onChange.bind(this, 'datDaThuNhaNuoc')}/>
                        </div>
                        <div className="col-100 no-gutter">
                          <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                          <Input className="col-25 mb0-18" name="tienPhaiTraCongDan" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDan} onChange={this.onChange.bind(this, 'tienPhaiTraCongDan')}/>
                          <Input className="col-25 mb0-18" name="datPhaiTraCongDan" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDan} onChange={this.onChange.bind(this, 'datPhaiTraCongDan')}/>
                          <Input className="col-25 mb0-18" name="tienDaTraCongDan" type="sdt" align="right" label="Đã trả tiền (đ)" value={this.state.tienDaTraCongDan} onChange={this.onChange.bind(this, 'tienDaTraCongDan')}/>
                          <Input className="col-25 mb0-18" type="sdt" name="datDaTraCongDan" align="right" label="Đã trả đất (m2)" value={this.state.datDaTraCongDan} onChange={this.onChange.bind(this, 'datDaTraCongDan')}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-100 no-gutter pt5 pb15">
                      <span className="line-border"></span>
                    </div>
                  </div>
                </ShowIf>
                <div className="col-100 no-gutter">
                  <ShowIfCheck label="Chuyển cơ quan điều tra(Nếu có)" onChange={this.handleCheck.bind(this, 'giaoCoQuanDieuTra')} checked={this.state.giaoCoQuanDieuTra}>
                    <div className="col-100 no-gutter mt5">
                      <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                      <div className="row pl10 pr10">
                        <DropDownChonCoQuanDieuTra name="DropDownChonCoQuanDieuTra" className="col-25" label="Tên cơ quan" bindValidator={this} require selectedValue={this.state.coQuanDieuTra} onChange={this.onChange.bind(this, 'coQuanDieuTra')}/>
                        <InputNumber className="col-25" label="Số vụ" name="soVuGiaoCoQuanDieuTra" value={this.state.soVuGiaoCoQuanDieuTra} onChange={this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra')}/>
                        <InputNumber className="col-25" label="Số đối tượng" name="soDoiTuongGiaoCoQuanDieuTra" value={this.state.soDoiTuongGiaoCoQuanDieuTra} onChange={this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra')} maxLength={255}/>
                      </div>
                      <ShowIf condition={this.state.allowAttachGiaoCoQuanDieuTra}>
                        <div className="col-100 no-gutter pb5">
                          <ContainerFileDinhKem name="GiaoCQDT" onSave={this.state.onSave} phanLoaiQuyTrinh='GIAO_CO_QUAN_DIEU_TRA' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.taiLieuVanThuGiaoCoQuanDieuTra} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                        </div>
                      </ShowIf>
                    </div>
                    <div className="col-100 no-gutter pt5 pb15">
                      <span className="line-border"></span>
                    </div>
                    <div className="col-100 no-gutter">
                      <ShowIfCheck label="Khởi tố" onChange={this.handleCheck.bind(this, 'khoiTo')} checked={this.state.khoiTo}>
                        <div className="col-100 no-gutter mt5">
                          <h2 className="title-12 mb15">Khởi tố</h2>
                          <div className="row pl10 pr10">
                            <div className="col-50 no-gutter mb20">
                              <InputNumber className="col-50 mb0-18" label="Số vụ" name="soVuBiKhoiTo" value={this.state.soVuBiKhoiTo} onChange={this.onChange.bind(this, 'soVuBiKhoiTo')}/>
                              <InputNumber className="col-50 mb0-18" label="Số đối tượng" name="soDoiTuongBiKhoiTo" value={this.state.soDoiTuongBiKhoiTo} onChange={this.onChange.bind(this, 'soDoiTuongBiKhoiTo')} maxLength={255}/>
                            </div>
                          </div>
                        </div>
                      </ShowIfCheck>
                    </div>
                  </ShowIfCheck>
                </div>
              </div>
                </ShowIf>

                <ShowIf condition={this.state.nextState === "GQDTTTXM_GIAO_PHONG_CUNG_CAP"}>
                  <DropDownChonPhongBanThuocCoQuan
                    className="col-25"
                    require
                    bindValidator={this}
                    selectedValue={this.state.phongBanChiDinh}
                    isValid={this.props.validate}
                    onChange={this.onChange.bind(this, 'phongBanChiDinh')}
                    name="dropdownChonPhongBanThuocCoQuan" />
                </ShowIf>

                <ShowIf condition={this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_CAN_BO" }>
                  <DropDownChonCanBoGiaiQuyet
                    isValid={this.state.validate}
                    selectedValue={this.state.canBoGiaiQuyet}
                    require
                    coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                    vaiTro={vaiTro}
                    bindValidator={this}
                    className="col-25"
                    label="Công chức giải quyết"
                    onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                    name="dropdownChonCanBoGiaiQuyet"
                  />
                </ShowIf>

                <ShowIf condition={this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" }>
                  <DropDownChonCanBoGiaiQuyet
                    isValid={this.state.validate}
                    selectedValue={this.state.canBoGiaiQuyet}
                    require
                    vaiTro="PHO_PHONG"
                    coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                    bindValidator={this}
                    className="col-25"
                    label="Chọn phó phòng"
                    onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                    name="dropdownChonCanBoGiaiQuyet"
                  />
                </ShowIf>
              <ShowIf condition={this.props.roleGQ === 'truongPhongKiemTraDeXuat'}>
                <div className="col-25">
                  <label className="pt-label">
                    <span className="val-title-bold">Hạn xử lý:</span>
                    <span className="val-content pt17 txt-danger">{this.state.ngayHetHanKTDX ? moment(this.state.ngayHetHanKTDX).format('DD/MM/YYYY') : ''}</span>
                  </label>
                </div>
              </ShowIf>
              <ShowIf condition={this.state.nextState !== "CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH"}>
                <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
              </ShowIf>
              <ShowIf condition={this.state.showFile}>
              <div className="col-100 pb5">
                <ContainerFileDinhKem name="KetThuc" onSave={this.state.onSave} phanLoaiQuyTrinh='' label="Danh sách văn bản xử lý" bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDon} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
              </div>
            </ShowIf>
            </div>
            <div className="box-bottom">
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <ShowIf condition={this.state.role === 'truongPhongGiaiQuyetDon'}>
                <span className="wrap-link">
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this, 'truongPhongGiaiQuyetDon')}><span>Lưu tạm</span></Link>
                  <ShowIf condition={(this.state.nextState === "CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH" || this.state.nextState === "CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN") && (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')}>
                    <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.openDialog.bind(this, 'openDialogLuuHoSo')}><span>{this.state.btnText}</span></Link>
                  </ShowIf>
                  <ConfirmDialog open={this.state.openDialogLuuHoSo} onClose={this.closeDialog.bind(this, 'openDialogLuuHoSo')} onSuccess={this.onSuccess.bind(this, 'openDialogLuuHoSo')} title={this.state.titleDialog} content={this.state.contentDialog}/>
                  <ShowIf condition={this.state.nextState !== '' && this.state.nextState !== 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH' && this.state.nextState !== 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN'}>
                    <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.handleGiaiQuyetDon.bind(this, 'truongPhongGiaiQuyetDon')}><span>Giao việc</span></Link>
                  </ShowIf>
                </span>
              </ShowIf>
              <ShowIf condition={this.state.role === 'truongPhongKiemTraDeXuat'}>
                <span className="wrap-link">
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this, 'truongPhongKiemTraDeXuat')}><span>Lưu tạm</span></Link>
                  <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.handleGiaiQuyetDon.bind(this, 'truongPhongKiemTraDeXuat')}><span>Giao việc</span></Link>
                </span>
              </ShowIf>

            </div>
          </form>
        </ShowIf>
        <ShowIf condition={this.props.alias === 'TruongPhongTTXMAction'}>
          <form className="form-action">
            <div className="row pl10 pr10">
              <ShowIf condition={this.props.loaiDon === 'DON_TO_CAO' && this.state.giaHanGiaiQuyet}>
                <div className="col-100 no-gutter mt5">
                  <div className="row pl10 pr10">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Gia hạn giải quyết tố cáo</p>
                    <Text red={true} className="col-25 mb10" label="Gia hạn đến ngày:" value={this.state.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                    <TextMessage className="col-100 mb15" label="Lý do gia hạn:" value={this.state.lyDoGiaHanGiaiQuyet}/>
                    <div className="col-100 pb15">
                      <span className="line-border"></span>
                    </div>
                  </div>
                </div>
              </ShowIf>

              <ShowIf condition={this.props.dataNextStates && this.props.dataNextStates.length > 1}>
                <DropDownMulipleUse
                  onRef={select => (this.select = select)}
                  className="col-25"
                  donId={this.state.id}
                  require
                  isValid={this.state.validate}
                  data={this.state.dataNextState}
                  keyName='type'
                  valueName='tenVietTat'
                  label="Hướng giải quyết"
                  bindValidator={this}
                  name="huongGiaiQuyet"
                  selectedValue={this.state.nextState}
                  onChange={this.onChange.bind(this, 'nextState')}/>
              </ShowIf>

              <ShowIf condition={this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" }>
                <DropDownChonCanBoGiaiQuyet
                  isValid={this.state.validate}
                  selectedValue={this.state.canBoGiaiQuyet}
                  require
                  vaiTro="PHO_PHONG"
                  coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                  bindValidator={this}
                  className="col-25"
                  label="Chọn phó phòng"
                  onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                  name="dropdownChonCanBoGiaiQuyet"
                />
                 <TextArea className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" value={this.state.yKienGiaiQuyet} onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaCanBoKetLuanNoiDung"/>
              </ShowIf>
              <ShowIf condition={this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_CAN_BO'}>
                <DropDownChonCanBoGiaiQuyet
                  isValid={this.state.validate}
                  selectedValue={this.state.canBoGiaiQuyet}
                  require
                  coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                  vaiTro={vaiTro}
                  bindValidator={this}
                  className="col-25"
                  label="Công chức giải quyết"
                  onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                  name="dropdownChonCanBoGiaiQuyet"
                />
                 <TextArea className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" value={this.state.yKienGiaiQuyet} onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaCanBoKetLuanNoiDung"/>
              </ShowIf>

              <ShowIf condition={this.state.nextState === "NHANTTXM_GIAO_PHONG_CUNG_CAP"}>
                <DropDownChonPhongBanThuocCoQuan
                  className="col-25"
                  require
                  bindValidator={this}
                  selectedValue={this.state.phongBanChiDinh}
                  isValid={this.props.validate}
                  onChange={this.onChange.bind(this, 'phongBanChiDinh')}
                  name="dropdownChonPhongBanThuocCoQuan" />
                   <TextArea className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" value={this.state.yKienGiaiQuyet} onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaCanBoKetLuanNoiDung"/>
              </ShowIf>

              <ShowIf condition={this.state.nextState === 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN'}>
                <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Lý do" bindValidator={this} channel='formTaoDon' require placeholder="Nhập..." onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet" maxLength={1000}/>
              </ShowIf>

              <ShowIf condition={this.state.nextState === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET'}>
                <TextArea className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" value={this.state.noiDung} onChange={this.onChange.bind(this, 'noiDung')} name="textareaCanBoKetLuanNoiDung"/>
                {
                  isQuaHan === true &&
                  <TextArea className="col-100" label="Lý do quá hạn" bindValidator={this} channel='formTaoDon' require value={this.state.lyDoQuaHan} placeholder="Nhập..." onChange={this.onChange.bind(this, 'lyDoQuaHan')} name="TextAreaLyDoQuaHan" maxLength={1000}/>
                }
              </ShowIf>
              <ShowIf condition={this.state.showAttach && this.state.nextState === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET'}>
                <div className="col-100 pb5">
                  <ContainerFileDinhKem name="CanBoChuyenVeDVGQ" onSave={this.state.onSave} bindValidator={this} dataShow={this.state.ListTaiLieuVanThuShow} data={this.state.ListTaiLieuVanThu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                </div>
              </ShowIf>
              <ShowIf condition={this.state.showAttach && this.state.nextState != 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET'}>
                <div className="col-100 pb5">
                  <ContainerFileDinhKem name="ListTaiLieuVanThu" hideDescription={true} dataShow={this.state.ListTaiLieuVanThuShow} disableAttachFile={this.state.nextState != 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN'}
                    onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                </div>
              </ShowIf>
            </div>
            <div className="box-bottom">
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <ShowIf condition={this.state.nextState != ''}>
                <span className="wrap-link">
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.saveTruongPhongGQD.bind(this)}><span>Lưu tạm</span></Link>
                  <ShowIf condition={this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" || this.state.nextState === "NHANTTXM_GIAO_PHONG_CUNG_CAP"}>
                    <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.truongPhongGQD.bind(this)}><span>Giao việc</span></Link>
                  </ShowIf>
                  <ShowIf condition={this.state.nextState === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET'}>
                    <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.openDialog.bind(this,'openDialog')}><span>{lbGuiTTXM}</span></Link>
                  </ShowIf>
                  <ShowIf condition={this.state.nextState === 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN'}>
                    <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.openDialog.bind(this,'openDialogTraDon')}><span>{lbTraTTXM}</span></Link>
                  </ShowIf>
                  <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this, 'openDialog')} onSuccess={this.onSuccess.bind(this, 'openDialog')} title="Xác nhận" content={"Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') +" báo cáo "+lb3+" của đơn/vụ việc này không?"}/>
                  <ConfirmDialog open={this.state.openDialogTraDon} onClose={this.closeDialog.bind(this, 'openDialogTraDon')} onSuccess={this.onSuccess.bind(this, 'openDialogTraDon')} title="Xác nhận" content={`Bạn có đồng ý trả đơn/vụ việc chuyển ${lb1} không đúng này cho ${this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : ''} không?`}/>
                </span>
              </ShowIf>
            </div>
          </form>
        </ShowIf>

        <Dialog
          isOpen={this.state.open}
          onClose={this.closeDialogConfirm.bind(this)}
          title='Xác nhận'
          className="reception-dialog delete-dialog wrap-block">
          <div className="pt-dialog-body">
            <p className="reception-dialog-text">{this.state.message}</p>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialogConfirm.bind(this)}><span>Không</span></Link>
            <Link className="btn-green" onClick={this.onSuccessDialogConfirm.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
      </section>
    );
  }
}

GiaiQuyetDonTruongPhong.defaultProps = {
  validators: {},
  tenCoQuan: [],
  ketQuaGiaiQuyetDon: [],
  donInfo: {},
  noRule: false
}

let bindStateToProps = state => {
  return {
    tenCoQuan: state.duLieuHeThong.donViTTXM,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(GiaiQuyetDonTruongPhong);



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/GiaiQuyetDonTruongPhong.jsx